<app-connect-with [state]="state$ | async"
                  (action)="onAction($event)">
</app-connect-with>
